export default "__VITE_ASSET__508a089f__"